export default __webpack_public_path__ + "static/media/banner3.bbd106b9.jpg";